// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"139":"052aec80","542":"2161624a"}[chunkId] + ".css";
};